<template>
  <footer class="footer">
    <ul>
      <li>
        <h1 href="#">产品中心</h1>
        <router-link to="/Product" href="#">产品介绍</router-link>
      </li>
      <li>
        <h1 href="#">解决方案</h1>
        <router-link to="/PrintSolution" href="#">图文快印解决方案（QQ/微信扫码付费打印）</router-link>
        <router-link to="/OfficeSolution" href="#">企业办公解决方案（企业微信/钉钉扫码打印）</router-link>
        <router-link to="/ShareSolution" href="#">共享打印解决方案（手机自助打印/远程打印）</router-link>
      </li>
      <li>
        <h1 href="#">关于我们</h1>
        <router-link to="/AboutUs" href="#">公司介绍</router-link>
      </li>
      <li>
        <h1 href="#">合作加盟</h1>
        <router-link to="/AboutUs" href="#">联系我们</router-link>
      </li>
      <li>
        <h1 href="#">关注我们</h1>
        <a href="#">关注微信公众号</a>
        <img src="../../assets/qr-code.png" height="80" width="80" alt="" />
      </li>
    </ul>
    <div class="ident">
      <span class="company">深圳市印点点科技有限公司</span><span>© 2015 - {{fullYear}} & <a href="https://beian.miit.gov.cn" target="_blank"> 粤ICP备15035377号</a> 请使用IE8+、Chrome、Firefox、360浏览器访问</span>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      fullYear: 2020,
    };
  },
  created() {
    this.fullYear = new Date().getFullYear(); //设置当前年份
  },
};
</script>

<style lang="stylus" scoped>
.footer {
  padding: 90px 0 0;
  background-color: #1d1f36;
  overflow: hidden;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  ul {
    width: 60%;
    padding: 0;
    list-style: none;
    float: left;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    li {
      h1 {
        font-size: 14px;
        color: #fff;
      }

      a {
        display: block;
        text-decoration: none;
        font-size: 12px;
        color: #bbb;
        margin: 23px 0 16px;
      }
    }
  }

  .ident {
    width: 100%;
    margin-top: 30px;
    padding: 30px 0 70px;
    text-align: center;
    color: #bbb;
    border-top: 1px solid rgba(255, 255, 255, 0.08);

    .company {
      margin-right: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comm/foot.vue